import { tr } from "../lib/i18n";

const box = { height: "auto", padding: 10 };

// One entry per line (why-us points)
function Lines({ value, onChange, dir, testid }) {
  return (
    <textarea rows={4} dir={dir} className="input" style={box} data-testid={testid}
      value={(value || []).join("\n")}
      onChange={(e) => onChange(e.target.value.split("\n").map((s) => s.trimStart()).filter((s, i, a) => s || i < a.length - 1))} />
  );
}

// "Title | subtitle" per line (home promise rows)
function Rows({ value, onChange, dir, testid }) {
  const text = (value || []).map((r) => [r.title, r.subtitle].filter(Boolean).join(" | ")).join("\n");
  const parse = (t) => t.split("\n").map((l) => {
    const [title, ...rest] = l.split("|");
    return { title: title.trim(), subtitle: rest.join("|").trim() };
  }).filter((r) => r.title);
  return <textarea rows={3} dir={dir} className="input" style={box} data-testid={testid} defaultValue={text} onBlur={(e) => onChange(parse(e.target.value))} />;
}

/** Customer reviews typed by Admin; the Arabic quote is optional (empty = English shown). */
function Reviews({ value, onChange }) {
  const list = value || [];
  const set = (i, k, v) => onChange(list.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  return (
    <div className="grid gap-3" style={{ gridColumn: "1 / -1" }} data-testid="set-reviews">
      <div className="eyebrow">{tr("x.reviews")}</div>
      {list.map((r, i) => (
        <div key={i} className="grid gap-2 p-3 rounded-lg border" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 240px), 1fr))" }}>
          <textarea rows={2} dir="ltr" className="input" style={box} placeholder={tr("x.review_quote_en")} value={r.quote || ""} onChange={(e) => set(i, "quote", e.target.value)} data-testid={`review-quote-${i}`} />
          <textarea rows={2} dir="rtl" className="input" style={box} placeholder={tr("x.review_quote_ar")} value={r.quote_ar || ""} onChange={(e) => set(i, "quote_ar", e.target.value)} data-testid={`review-quote-ar-${i}`} />
          <input dir="auto" className="input" placeholder={tr("x.review_by")} value={r.by || ""} onChange={(e) => set(i, "by", e.target.value)} data-testid={`review-by-${i}`} />
          <button type="button" className="btn-secondary" style={{ width: "fit-content" }} onClick={() => onChange(list.filter((_, j) => j !== i))} data-testid={`review-remove-${i}`}>{tr("x.remove")}</button>
        </div>
      ))}
      <button type="button" className="btn-secondary" style={{ width: "fit-content" }} onClick={() => onChange([...list, { quote: "", quote_ar: "", by: "" }])} data-testid="review-add">{tr("x.add")}</button>
    </div>
  );
}

/** Public website texts, English next to Arabic. Arabic left empty = English is shown. */
export function PublicTextsFields({ form, patch, Field }) {
  const pair = (k, label, area) => (
    <>
      <Field label={`${label} · ${tr("x.lang_en")}`} wide={area}>
        {area ? <textarea rows={3} dir="ltr" className="input" style={box} value={form[k] || ""} onChange={(e) => patch(k, e.target.value)} data-testid={`set-${k}`} />
          : <input dir="ltr" className="input" value={form[k] || ""} onChange={(e) => patch(k, e.target.value)} data-testid={`set-${k}`} />}
      </Field>
      <Field label={`${label} · ${tr("x.lang_ar")}`} wide={area}>
        {area ? <textarea rows={3} dir="rtl" className="input" style={box} value={form[`${k}_ar`] || ""} onChange={(e) => patch(`${k}_ar`, e.target.value)} data-testid={`set-${k}-ar`} />
          : <input dir="rtl" className="input" value={form[`${k}_ar`] || ""} onChange={(e) => patch(`${k}_ar`, e.target.value)} data-testid={`set-${k}-ar`} />}
      </Field>
    </>
  );
  return (
    <>
      <div className="text-xs opacity-70" style={{ gridColumn: "1 / -1" }}>{tr("x.ar_fallback_note")}</div>
      {pair("public_meta_description", tr("x.meta_description"), true)}
      {pair("public_tagline", tr("x.tagline"))}
      {pair("public_opening_hours", tr("x.opening_hours"), true)}
      {pair("public_about_text", tr("x.about_text"), true)}
      {pair("finance_disclaimer", tr("x.finance_disclaimer"))}
      <Field label={`${tr("x.why_us_points")} · ${tr("x.lang_en")}`} wide><Lines dir="ltr" value={form.public_why_us_points} onChange={(v) => patch("public_why_us_points", v)} testid="set-why-us" /></Field>
      <Field label={`${tr("x.why_us_points")} · ${tr("x.lang_ar")}`} wide><Lines dir="rtl" value={form.public_why_us_points_ar} onChange={(v) => patch("public_why_us_points_ar", v)} testid="set-why-us-ar" /></Field>
      <Field label={`${tr("x.promise_rows")} · ${tr("x.lang_en")}`} wide><Rows dir="ltr" value={form.public_promise_rows} onChange={(v) => patch("public_promise_rows", v)} testid="set-promise" /></Field>
      <Field label={`${tr("x.promise_rows")} · ${tr("x.lang_ar")}`} wide><Rows dir="rtl" value={form.public_promise_rows_ar} onChange={(v) => patch("public_promise_rows_ar", v)} testid="set-promise-ar" /></Field>
      <Reviews value={form.public_reviews} onChange={(v) => patch("public_reviews", v)} />
    </>
  );
}
